// PRC-046: Margin Center usa el formato común de Pricing (formatNumber.ts):
// coma decimal y punto de miles también con cuatro cifras.
import { pricingNumberFormat } from '../../pricingJourney/formatNumber';


export function formatMarginCenterNumber(
  value: number | null | undefined,
  maximumFractionDigits = 2,
): string {
  if (value === null || value === undefined) {
    return '—';
  }

  return pricingNumberFormat({ maximumFractionDigits }).format(value);
}


export function formatMarginCenterCurrency(
  value: number | null | undefined,
  currencyCode: string | null,
  maximumFractionDigits = 2,
): string {
  if (value === null || value === undefined) {
    return '—';
  }

  if (!currencyCode) {
    return formatMarginCenterNumber(
      value,
      maximumFractionDigits,
    );
  }

  try {
    return pricingNumberFormat({
      style: 'currency',
      currency: currencyCode,
      maximumFractionDigits,
    }).format(value);
  } catch {
    return formatMarginCenterNumber(
      value,
      maximumFractionDigits,
    );
  }
}
